import React from "react";

const Loading = props => (
    <h2></h2>
);

export default Loading;
